import React, { Component } from 'react'
import axios from 'axios'
import ls from 'local-storage'
import swal from 'sweetalert'

export class Manpower extends Component {
    constructor(props){     
        super(props);   
        this.state = {
          errors: {},
          details:{},
          agencyid:''
         } 
         this.handleChange = this.handleChange.bind(this);  
      }    
    componentDidMount() {
        document.title = "Contractor Man Power"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;        
        if(this.props.children){
          this.setState({agencyid:this.props.children}); 
          Axios.get(`${process.env.REACT_APP_API_URL}contractor/contractormanpower/agencyid/`+this.props.children)
        .then(result=>{
          if(result.status === 200){
            console.log(result.data.data);
            this.setState({details:result.data.data});                      
          }      
        });      
      }        
    }
    handleValidation(){
        let details = this.state.details;        
        let errors = {};
        let formIsValid = true;
        
        //Degree Engineers Nos.
        if(!details["degree_eng_no"]){
          formIsValid = false;
          errors["degree_eng_no"] = "Please Enter Degree Engineers Nos.";
        }
        
        if(typeof details["degree_eng_no"] !== "undefined" && typeof details["degree_eng_no"] !== "number"){
            formIsValid = false;
            errors["degree_eng_no"] = "Only letters";
        }
        //Diploma Engineers Nos..
        if(!details["diploma_eng_no"]){
            formIsValid = false;
            errors["diploma_eng_no"] = "Please Enter Diploma Engineers Nos.";
          }
          
          if(typeof details["diploma_eng_no"] !== "undefined" && typeof details["diploma_eng_no"] !== "number"){
              formIsValid = false;
              errors["diploma_eng_no"] = "Only letters";
          }         
        //Other Manpower Nos.
        if(!details["other_manpower_no"]){
            formIsValid = false;
            errors["other_manpower_no"] = "Please Enter Other Manpower Nos.";
        }
        
        if(typeof details["other_manpower_no"] !== "undefined" && typeof details["other_manpower_no"] !== "number"){
            formIsValid = false;
            errors["other_manpower_no"] = "Only letters";
        }      
      
        this.setState({errors: errors});
        return formIsValid;
      }    
    contactSubmit(e){        
        e.preventDefault();
        if(this.handleValidation()){
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const data =  this.state.details;  
          Axios.post(`${process.env.REACT_APP_API_URL}contractor/insertcontractormanpower`, data) 
            .then((responce) => { 
              const result = responce.data;
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Redirect To Contractor List",
                  icon: "success",
                  buttons: true
                })              
            }
            else{
              swal("Error", result.msg, "error");               
            }              
            });
        }   
      }    
    async handleChange(event) {
        let details = this.state.details;
        let errors = this.state.errors;
        details[event.target.name] = event.target.value;   
        errors[event.target.name] = '';      
        this.setState({details,errors});       
      } 
      onFileChange = event => {
        let details = this.state.details;
        console.log(event.target.files[0]);
        details['file']= event.target.files[0]
        this.setState({details});      
      };         
    render() {
        return (
                <div className="box-body">
                   <form onSubmit= {this.contactSubmit.bind(this)}>
                        <div className="col-md-12">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Degree Engineers Nos.</label>
                                        <input className="form-control" type="text" name="degree_eng_no" value={this.state.details.degree_eng_no || ''} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Diploma Engineers Nos.</label>
                                    <input className="form-control" type="text" name="diploma_eng_no" value={this.state.details.diploma_eng_no || ''} onChange={this.handleChange} />
                                </div>						
                            </div>						 
                        </div>
                        <div className="col-md-12">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Other Manpower Nos.</label>
                                        <input className="form-control" type="text" name="other_manpower_no" value={this.state.details.other_manpower_no || ''} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Manpower Details PDF.</label>
                                    <input className="form-control" type="file" name="manpower_details_pdf" onChange={this.onFileChange} />																	 
                                </div>						
                            </div>						 
                        </div>					
                        <div className="box-footer">
                            <button type="submit" className="btn btn-primary pull-right" name="Update">Save</button>
                        </div>
                </form>
                </div>      
        )
    }
}
export default Manpower